import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=fb20eecc&"
import script from "./sideMenu.js?vue&type=script&lang=js&"
export * from "./sideMenu.js?vue&type=script&lang=js&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=fb20eecc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports